// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-section {
  margin-bottom: 150px;
  position: relative;
}
@media (max-width: 1023px) {
  .video-section {
    margin-bottom: 96px;
  }
}
.video-section .section-title {
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #283583;
  margin-bottom: 72px;
  line-height: 1.3;
}
@media (max-width: 1023px) {
  .video-section .section-title {
    font-size: 39px;
    margin-bottom: 40px;
    text-align: center;
  }
}
.video-section .container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.video-section .video-container {
  position: relative;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  height: auto;
  background-color: #072146;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.video-section .video-container:hover {
  transform: translateY(-10px);
}
.video-section .video-container:hover .play-button {
  transform: scale(1.1);
  background-color: #0ad286;
}
.video-section .video-container img {
  width: 100%;
  height: 100%;
  aspect-ratio: 16/7;
  object-fit: cover;
  display: block;
  transition: all 0.5s ease;
}
@media (max-width: 1023px) {
  .video-section .video-container img {
    aspect-ratio: 4/3;
  }
}
.video-section .video-container .play-info {
  position: absolute;
  bottom: 70px;
  left: 70px;
  display: flex;
  align-items: center;
  z-index: 2;
}
.video-section .video-container .play-info .play-button {
  width: 100px;
  height: 100px;
  background-color: #09B175;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 32px;
  position: relative;
  animation: pulse-play 1.8s infinite ease-out;
}
.video-section .video-container .play-info .play-button:hover {
  transform: scale(1.1);
  animation-play-state: paused;
  background-color: #0ad286;
}
.video-section .video-container .play-info .play-button img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
.video-section .video-container .play-info .play-button::after {
  content: none;
}
.video-section .video-container .play-info .play-text {
  color: #fff;
  font-size: 40px;
  font-weight: 400;
}
@media (max-width: 767px) {
  .video-section .video-container {
    border-radius: 15px;
  }
  .video-section .video-container .play-info {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    top: 50%;
    bottom: auto;
    transform: translateY(-50%);
  }
  .video-section .video-container .play-info .play-button {
    width: 50px;
    height: 50px;
    margin-right: 0;
    animation: none;
  }
  .video-section .video-container .play-info .play-button img {
    width: 20px;
    height: 20px;
  }
  .video-section .video-container .play-info .play-text {
    font-size: 18px;
    text-align: center;
  }
}

.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
.video-modal.active {
  opacity: 1;
  visibility: visible;
}
.video-modal .close-video {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.6);
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 0 10px 0 10px;
  transition: background-color 0.3s ease;
}
.video-modal .close-video:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.video-modal .close-video img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: invert(1);
  transition: all 0.3s ease;
}
.video-modal .close-video img:hover {
  transform: rotate(90deg);
}
.video-modal .close-video:hover img {
  opacity: 0.7;
}
.video-modal .video-modal-content {
  position: relative;
  width: 90%;
  max-width: 1000px;
  background-color: #000;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 auto;
}
.video-modal .video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
}
.video-modal .video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

@keyframes pulse-play {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(9, 177, 117, 0.7);
  }
  70% {
    transform: scale(1.12);
    box-shadow: 0 0 0 20px rgba(9, 177, 117, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(9, 177, 117, 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/video/Video.scss"],"names":[],"mappings":"AACA;EACI,oBAAA;EAKA,kBAAA;AAJJ;AACI;EAHJ;IAIQ,mBAAA;EAEN;AACF;AACI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AACR;AAEQ;EATJ;IAUQ,eAAA;IACA,mBAAA;IACA,kBAAA;EACV;AACF;AAEI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAAR;AAGI;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qDAAA;AADR;AAGQ;EACI,4BAAA;AADZ;AAKY;EACI,qBAAA;EACA,yBAAA;AAHhB;AAOQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AALZ;AAOY;EARJ;IASQ,iBAAA;EAJd;AACF;AAOQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AALZ;AAOY;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,4CAAA;AANhB;AAQgB;EACI,qBAAA;EACA,4BAAA;EACA,yBAAA;AANpB;AASgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAPpB;AAUgB;EACI,aAAA;AARpB;AAYY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AAVhB;AAeI;EACI;IACI,mBAAA;EAbV;EAeU;IACI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,2BAAA;EAbd;EAec;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;EAblB;EAekB;IACI,WAAA;IACA,YAAA;EAbtB;EAiBc;IACI,eAAA;IACA,kBAAA;EAflB;AACF;;AAsBA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAnBJ;AAqBI;EACI,UAAA;EACA,mBAAA;AAnBR;AAsBI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,4BAAA;EACA,sCAAA;AApBR;AAsBQ;EACI,oCAAA;AApBZ;AAwBQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAtBZ;AAwBY;EACC,wBAAA;AAtBb;AA0BQ;EACI,YAAA;AAxBZ;AA4BI;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA1BR;AA6BI;EACI,kBAAA;EACA,sBAAA,EAAA,sBAAA;EACA,SAAA;EACA,gBAAA;AA3BR;AA6BQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AA3BZ;;AAiCA;EACI;IACI,mBAAA;IACA,0CAAA;EA9BN;EAgCE;IACI,sBAAA;IACA,2CAAA;EA9BN;EAgCE;IACI,mBAAA;IACA,wCAAA;EA9BN;AACF","sourcesContent":["// Video Section - Güncellenmiş tasarım\n.video-section {\n    margin-bottom: 150px;\n\n    @media (max-width: 1023px) {\n        margin-bottom: 96px;\n    }\n    position: relative;\n    \n    .section-title {\n        text-align: center;\n        font-size: 45px;\n        font-weight: 700;\n        color: #283583;\n        margin-bottom: 72px;\n        line-height: 1.3;\n\n        \n        @media (max-width: 1023px) {\n            font-size: 39px;\n            margin-bottom: 40px;\n            text-align: center;\n        }\n    }\n    \n    .container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .video-container {\n        position: relative;\n        width: 100%;\n        border-radius: 20px;\n        overflow: hidden;\n        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n        height: auto;\n        background-color: #072146;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        transition: transform 0.3s ease, box-shadow 0.3s ease;\n        \n        &:hover {\n            transform: translateY(-10px);\n           \n         \n            \n            .play-button {\n                transform: scale(1.1);\n                background-color: #0ad286;\n            }\n        }\n        \n        img {\n            width: 100%;\n            height: 100%;\n            aspect-ratio: 16 / 7;\n            object-fit: cover;\n            display: block;\n            transition: all 0.5s ease;\n\n            @media (max-width: 1023px) {\n                aspect-ratio: 4 / 3;\n            }\n        }\n        \n        .play-info {\n            position: absolute;\n            bottom: 70px;\n            left: 70px;\n            display: flex;\n            align-items: center;\n            z-index: 2;\n            \n            .play-button {\n                width: 100px;\n                height: 100px;\n                background-color: #09B175;\n                border-radius: 50%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                cursor: pointer;\n                transition: all 0.3s ease;\n                margin-right: 32px;\n                position: relative;\n\n                animation: pulse-play 1.8s infinite ease-out;\n\n                &:hover {\n                    transform: scale(1.1);\n                    animation-play-state: paused;\n                    background-color: #0ad286;\n                }\n                \n                img {\n                    width: 48px;\n                    height: 48px;\n                    object-fit: contain;\n                }\n                \n                &::after {\n                    content: none;\n                }\n            }\n            \n            .play-text {\n                color: #fff;\n                font-size: 40px;\n                font-weight: 400;\n            }\n        }\n    }\n    \n    @media (max-width: 767px) {\n        .video-container {\n            border-radius: 15px;\n            \n            .play-info {\n                position: absolute;\n                left: 0;\n                right: 0;\n                width: 100%;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                gap: 10px;\n                top: 50%;\n                bottom: auto;\n                transform: translateY(-50%);\n                \n                .play-button {\n                    width: 50px;\n                    height: 50px;\n                    margin-right: 0;\n                    animation: none;\n                    \n                    img {\n                        width: 20px;\n                        height: 20px;\n                    }\n                }\n                \n                .play-text {\n                    font-size: 18px;\n                    text-align: center;\n                }\n            }\n        }\n    }\n}\n\n// Video modal stillerini ekleyelim - style.scss'e ekleyin\n.video-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n    \n    &.active {\n        opacity: 1;\n        visibility: visible;\n    }\n    \n    .close-video {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 40px;\n        height: 40px;\n        background-color: rgba(0, 0, 0, 0.6); \n        border: none;\n        padding: 0;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 10;\n        border-radius: 0 10px 0 10px;\n        transition: background-color 0.3s ease;\n\n        &:hover {\n            background-color: rgba(0, 0, 0, 0.8);\n        }\n        \n        \n        img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            filter: invert(1);\n            transition: all 0.3s ease;\n\n            &:hover {\n             transform: rotate(90deg);\n            }\n        }\n        \n        &:hover img {\n            opacity: 0.7;\n        }\n    }\n    \n    .video-modal-content {\n        position: relative;\n        width: 90%;\n        max-width: 1000px;\n        background-color: #000;\n        border-radius: 10px;\n        overflow: hidden;\n        margin: 0 auto;\n    }\n    \n    .video-wrapper {\n        position: relative;\n        padding-bottom: 56.25%; /* 16:9 aspect ratio */\n        height: 0;\n        overflow: hidden;\n        \n        iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            border: 0;\n        }\n    }\n}\n\n// Play button pulse animation\n@keyframes pulse-play {\n    0% {\n        transform: scale(1);\n        box-shadow: 0 0 0 0 rgba(9, 177, 117, 0.7); // Başlangıç gölge opaklığını artır\n    }\n    70% {\n        transform: scale(1.12); // Büyüme oranını artır\n        box-shadow: 0 0 0 20px rgba(9, 177, 117, 0); // Gölge yayılmasını artır\n    }\n    100% {\n        transform: scale(1);\n        box-shadow: 0 0 0 0 rgba(9, 177, 117, 0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
